import { render, staticRenderFns } from "./CabinetORSubcolConfig.vue?vue&type=template&id=70705c7a&"
import script from "./CabinetORSubcolConfig.vue?vue&type=script&lang=js&"
export * from "./CabinetORSubcolConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports